import React from 'react';
import { useAppData } from '../AppContext';
import { DEF_HOW_IT_WORKS } from '../store';
import './HowItWorks.css';

const HowItWorks = () => {
  const { howItWorks } = useAppData();
  const d = howItWorks || DEF_HOW_IT_WORKS;

  return (
    <section className="how-it-works-section">
      <div className="hiw-container">
        <span className="hiw-eyebrow" data-aos="fade-up">{d.eyebrow}</span>
        <h2 className="hiw-heading" data-aos="fade-up" data-aos-delay="60">{d.heading}</h2>

        <div className="hiw-layout" data-aos="fade-up" data-aos-delay="100">
          <div className="hiw-text">
            <p>{d.para1}</p>
            <p>{d.para2}</p>
            <p>{d.para3}</p>

            <div className="hiw-diagram">
              <div className="diagram-columns">
                <div className="diagram-col">
                  <div className="diagram-col-title galvanic-title">GALVANIC - NO CORROSION</div>
                  <div className="diagram-impact">IMPACT</div>
                  <div className="layer-stack">
                    <div className="layer layer-zinga">ZINGA</div>
                    <div className="layer layer-iron-safe">IRON</div>
                  </div>
                </div>
                <div className="diagram-col">
                  <div className="diagram-col-title nongalvanic-title">NON GALVANIC - CORROSION</div>
                  <div className="diagram-impact">IMPACT</div>
                  <div className="layer-stack">
                    <div className="layer layer-paint">PAINT</div>
                    <div className="layer layer-iron-rust">IRON</div>
                  </div>
                </div>
              </div>

              <div className="diagram-info">
                <div className="info-row">
                  <div className="info-cell">
                    <span className="info-label">PROTECTING LAYER</span>
                    <span className="info-val">ZINC-SYSTEMS = ACTIVE SYSTEMS</span>
                  </div>
                  <div className="info-cell">
                    <span className="info-label">PROTECTING LAYER</span>
                    <span className="info-val">PAINT-SYSTEMS = PASSIVE SYSTEMS</span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-cell">
                    <span className="info-label">REACTION DUE TO AIR AND MOISTURE</span>
                    <span className="info-val">O₂ + 2H₂O + 4e⁻ → 4OH⁻</span>
                    <span className="info-val">Zn → Zn²⁺ + 2e⁻</span>
                  </div>
                  <div className="info-cell">
                    <span className="info-label">REACTION DUE TO AIR AND MOISTURE</span>
                    <span className="info-val">O₂ + 2H₂O + 4e⁻ → 4OH⁻</span>
                    <span className="info-val">Fe → Fe²⁺ + 2e⁻</span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-cell">
                    <span className="info-label">FORMATION OF:</span>
                    <span className="info-val">ZnO</span>
                  </div>
                  <div className="info-cell">
                    <span className="info-label">FORMATION OF:</span>
                    <span className="info-val">Fe₂O₃</span>
                  </div>
                </div>
              </div>
            </div>

            <p style={{ marginTop: '24px' }}>{d.paraBottom}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;

